import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { Logo } from "@/components/brand/logo";
import { DotLoader } from "@/components/ui/spinner";

export function AuthLayout() {
	return (
		<div className="bg-blueprint relative flex min-h-dvh flex-col items-center justify-center px-4 py-12">
			<div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_30%,var(--background)_75%)]" />
			<div className="relative flex w-full max-w-[380px] flex-col items-center gap-8">
				<Logo className="h-7" />
				<div className="crop-marks w-full p-px [--len:10px]">
					<div className="rounded-lg border bg-card p-6 shadow-sm">
						<Suspense
							fallback={
								<div className="flex h-64 items-center justify-center text-muted-foreground">
									<DotLoader />
								</div>
							}
						>
							<Outlet />
						</Suspense>
					</div>
				</div>
				<p className="mono-label text-center">Blueprint your content · broadcast on autopilot</p>
			</div>
		</div>
	);
}
